import { http } from "@/request/http";

export default {
  state: () => ({
    //当前
    selectedMyCate: "",
    //用户分类
    userCateList: [],
    //系统分类
    systemCateList: [],
  }),

  mutations: {
    ChangeSelectedMyCate(state, value) {
      state.selectedMyCate = value;
    },
    SetUserCateList(state, value) {
      state.userCateList = value;
    },
    SetSystemCateList(state, value) {
      state.systemCateList = value;
    },
  },

  getters: {},

  actions: {
    fetchUserCateList(store, force = false) {
      if (store.state.userCateList.length > 0 && !force) return;
      http.get("/app-api/model/asset-user-cate/tree").then((res) => {
        store.commit("SetUserCateList", res);
      });
    },
    fetchSystemCateList(store, force = false) {
      if (store.state.systemCateList.length > 0 && !force) return;
      // http.get('/app-api/product/category/treeList').then(res => {
      http.get("/app-api/product/category/treeList").then((res) => {
        store.commit("SetSystemCateList", res);
      });
    },
  },
};
